import ko from "knockout";
import { MaybeObservable } from "flow/interfaces/MaybeObservable";
import { cleanHtml } from "flow/utils/cleanHtml";

export interface ISafeHtmlParams {
    html: MaybeObservable<string>;
}

class SafeHtmlViewModel {
    html: MaybeObservable<string>;

    constructor(params: ISafeHtmlParams, templateNodes: any[]) {
        if (params.html !== undefined) {
            this.html = ko.pureComputed(() => cleanHtml(ko.unwrap(params.html)));
        } else {
            // If html param is undefined, it can never become anything else.
            // So if that is the case, we will try using anything that was passed
            // as body to this component.

            // We convert the template nodes to a string using a div.
            const div = document.createElement("div");
            templateNodes.forEach(node => {
                div.appendChild(node);
            });

            this.html = cleanHtml(div.innerHTML);

            // Finally, clean up the div
            div.innerHTML = "";
        }
    }
}

ko.components.register("ko-safe-html", {
    viewModel: {
        createViewModel: (params: ISafeHtmlParams, componentInfo: any) => {
            return new SafeHtmlViewModel(params, componentInfo.templateNodes);
        }
    },
    template: "{{{html}}}",
    synchronous: true
});
